import {
  SEND_INVITE_REQUEST,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_FAILED,
  GET_DATA_FOR_INVITE_FORM_REQUEST,
  GET_DATA_FOR_INVITE_FORM_SUCCESS,
  GET_DATA_FOR_INVITE_FORM_FAILED,
} from './actionTypes';

const initialState = {
  loading: false,
  error: '',
  organizations: [],
  registrationForms: [],
};

const rolesSelectReducer = (state = initialState, {
  type, error, organizations, registrationForms,
}) => {
  switch (type) {
    case GET_DATA_FOR_INVITE_FORM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_FOR_INVITE_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        organizations,
        registrationForms,
      };
    case GET_DATA_FOR_INVITE_FORM_FAILED:
      return {
        ...state,
        loading: false,
        error,
      };
    case SEND_INVITE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SEND_INVITE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SEND_INVITE_FAILED:
      return {
        ...state,
        error,
        loading: false,
      };
    default:
      return state;
  }
};

export default rolesSelectReducer;
